import { client } from './axios';

const history = (id) => client.get(`/order/history/${id}`,);
const historyList = (params) => client.get(`/order/history`, { params });

export const commonService = {
    history,
    historyList
};
